"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Slider = void 0;
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const slider_1 = __importDefault(require("@react-native-community/slider"));
const Slider_style_1 = require("./Slider.style");
const atome_1 = require("../../atome");
const range = (start, end) => Array.from({ length: end - start }, (v, k) => k + start);
const outputScale = (minimumValue, maximumValue) => {
    return range(minimumValue, maximumValue + 1).map((value, index) => {
        return (react_1.default.createElement(atome_1.Text, { style: [{ color: '#b3b3b3', width: 15, textAlign: 'center' }], key: index }, value));
    });
};
function Slider({ value, minimumValue, maximumValue, step, disabled = false, thumbTintColor = '#3db384', minimumTrackTintColor = '#c2c2c2', maximumTrackTintColor = '#c2c2c2', onValueChange, style = [], showScale = false }) {
    return (react_1.default.createElement(react_native_1.View, { style: Slider_style_1.styles.container },
        showScale && (react_1.default.createElement(react_native_1.View, { style: Slider_style_1.styles.scale }, outputScale(minimumValue, maximumValue))),
        react_1.default.createElement(slider_1.default, { style: [Slider_style_1.styles.slider, ...style], value: value, minimumValue: minimumValue, maximumValue: maximumValue, step: step, disabled: disabled, thumbTintColor: thumbTintColor, minimumTrackTintColor: minimumTrackTintColor, maximumTrackTintColor: maximumTrackTintColor, onValueChange: onValueChange })));
}
exports.Slider = Slider;
